import { Component, Output, EventEmitter } from '@angular/core';

@Component({
	selector: 'event-cancel-dialog-presentation',
	styles: [require('./event-cancel-dialog.presentation.scss')],
	template: `
		<div class="event-cancel-dialog">
			<div class="event-cancel__header">
				Das leoticket-Team wird über die Absage der Veranstaltung informiert.<br>
				Bitte teilen Sie uns den Grund der Absage mit.<br>
				<br>
				Behalten die Karten ihre Gültigkeit?<br>
				Oder...<br>
				<ul>
					<li>sollen wir stornieren und den Kartenpreis erstatten?</li>
					<li>sollen wir versuchen die Kartenkäufer auf einen anderen Termin umzubuchen,<br> wenn diese damit einverstanden sind?</li>
				</ul>
				<div class="hint--important">
					Teilen Sie uns unbedingt mit, wenn Sie für diese Veranstaltung bereits Abschlagszahlungen erhalten haben!
				</div>
			</div>
			<form>
				<label for="custom-message" class="form__label">Ihre Mitteilung an das leoticket-Team:</label>
				<textarea rows="10" type="text" class="form__textarea" id="custom-message" name="custom-message"
					[(ngModel)]="messageFromMerchant">
				</textarea>
			</form>
			<div class="event-cancel-dialog__buttons">
				<button (click)="backClicked.emit()" class="button--bright-blue">Zurück</button>
				<button (click)="confirmCancellationClicked.emit(messageFromMerchant)" class="button--moderate-red">Absage bestätigen</button>
			</div>
		</div>
	`
})
export class EventCancelDialogPresentation {
	messageFromMerchant: string;

	@Output() backClicked: EventEmitter<void> = new EventEmitter<void>();
	@Output() confirmCancellationClicked: EventEmitter<string> = new EventEmitter<string>();
}



// WEBPACK FOOTER //
// ./src/app/components/event-components/event-status/event-cancel-dialog/event-cancel-dialog.presentation.ts